import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';
import {DatetimeModule} from '../../components/datetime/datetime.module';
import {NoticesService} from '../../services/notices.service';
import {PlaylistAndNoticesListComponent} from './playlist-and-notices-list/playlist-and-notices-list.component';
import {NoticesComponent} from './notices.component';
import {CreateNoticeWizardComponent} from './create-notice-wizard/create-notice-wizard.component';
import {CreateNoticeModalComponent} from './create-notice-modal/create-notice-modal.component';
import {ScheduleNoticeModalComponent} from './schedule-notice-modal/schedule-notice-modal.component';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {NoticeInfoModalComponent} from './notice-info-modal/notice-info-modal.component';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {ChooseIconModalComponent} from './choose-icon-modal/choose-icon-modal.component';
import {TagSelect} from '../../components/tag-select/multiselect.component';
import {ZoomImageModalComponent} from './zoom-image-modal/zoom-image-modal.component';
import { FileDropModule } from 'angular2-file-drop';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        AngularMaterialImportModule,
        PdfViewerModule,
        TagSelect,
        FileDropModule,
        UtilsModule
    ],
    declarations: [
        NoticesComponent,
        PlaylistAndNoticesListComponent,
        CreateNoticeWizardComponent,
        CreateNoticeModalComponent,
        ScheduleNoticeModalComponent,
        NoticeInfoModalComponent,
        ChooseIconModalComponent,
        ZoomImageModalComponent
    ],
    providers: [
        NoticesService
    ]
})
export class NoticesModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/notices/notices.module.ts